import ENDPOINT from "@/config/endpoint";
const replaceUrl = (path, baseUrl, replaceUrl, replaceUrlHttps) => {
  if (path && path.includes(replaceUrl)) {
    path = path.replace(replaceUrl, baseUrl);
  }

  if (path && path.includes(replaceUrlHttps)) {
    path = path.replace(replaceUrlHttps, baseUrl);
  }

  if (!path || path.includes("http") || path.includes("https")) {
    return path;
  }
  return path.startsWith("/") ? `${baseUrl}${path}` : `${baseUrl}/${path}`;
};

export const replaceUrlResourceBlog = (path) => {
  return replaceUrl(
    path,
    ENDPOINT.BACKEND_URL,
    "http://127.0.0.1:8000",
    "https://api.blog.lumitus.com.vn"
  );
};
